<template>
  <div>
    <div v-if="!hideSwitchTab" class="flex border-b border-[#E0E0E0]">
      <div
        data-testid="my-calendar.tab-switch-panel.appointment-tab"
        :class="['switch-tab', { active: modelValue === 'appointment' }]"
        @click="switchTab('appointment')"
      >
        <img
          src="@/assets/my-calendar/calendar/calendar.svg"
          alt="switch-to-calendar"
          :class="{ 'tab-icon-gray': modelValue !== 'appointment' }"
        />
        <span>Appointment</span>
      </div>
      <div
        data-testid="my-calendar.tab-switch-panel.task-tab"
        :class="['switch-tab', { active: modelValue === 'task' }]"
        @click="switchTab('task')"
      >
        <img src="@/assets/my-calendar/alarm.svg" alt="switch-to-task" />
        <span>Task</span>
      </div>
    </div>
    <div >
      <ScheduleAppointmentPanel
        v-show="modelValue === 'appointment'"
        :activeTab="modelValue"
        :disable-patient-selector="disablePatientSelector"
        @update:disabled="scheduleDisableBtn = $event"
      />
      <ScheduleTaskPanel
        v-show="modelValue === 'task'"
        :activeTab="modelValue"
        :disable-patient-selector="disablePatientSelector"
        @update:disabled="taskDisableBtn = $event"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import ScheduleAppointmentPanel from './ScheduleAppointmentPanel.vue';
import ScheduleTaskPanel from './ScheduleTaskPanel.vue';
// import { useStore } from 'vuex'

// const store = useStore()

const props = defineProps({
  modelValue: {
    type: String,
    required: true
  },
  hideSwitchTab: {
    type: Boolean,
    default: false
  },
  disablePatientSelector: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue','update:disabled']);
const switchTab = (tab) => {
  emit('update:modelValue', tab);
};
const scheduleDisableBtn = ref(false)
const taskDisableBtn = ref(false)
const anyDisable = computed(() => {
  if (props.modelValue === 'appointment') {
    return scheduleDisableBtn.value;
  } else if (props.modelValue === 'task') {
    return taskDisableBtn.value;
  }
});
watch(anyDisable, (val) => {
  emit('update:disabled', val)
}, { immediate: true })




</script>

<style scoped>
.switch-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  cursor: pointer;
  color: #666666;
  font-weight: 400;
  font-size: 14px;
}
.switch-tab.active {
  background-color: #F9FBFD;
  color: #004879;
  border: 1px solid #004879;
  border-radius: 4px 4px 0 0;
  font-weight: 500;
}
.tab-icon-gray {
  filter: grayscale(1) brightness(1.3); 
}
</style>